(function() {
  function initDiamondOriginSelector() {
    const containers = document.querySelectorAll('.diamond-origin-selector-container');
    if (containers.length === 0) return;

    containers.forEach(container => {
      const buttons = container.querySelectorAll('.diamond-origin-button');
      const activeLabel = container.querySelector('.diamond-origin-active');

      if (!buttons.length || !activeLabel) return;

      // Click handlers for origin buttons
      buttons.forEach(button => {
        button.addEventListener('click', function() {
          const label = this.dataset.label;
          
          // Remove active class from all buttons
          buttons.forEach(b => b.classList.remove('active'));
          
          // Add active class to clicked button
          this.classList.add('active');
          
          // Update label text
          if (activeLabel && label) {
            activeLabel.textContent = label;
          }
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiamondOriginSelector);
  } else {
    initDiamondOriginSelector();
  }

  // Re-initialize for theme editor
  document.addEventListener('shopify:section:load', initDiamondOriginSelector);
})();

